/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MTAPort } from '../model';
// @ts-ignore
import type { PostfixMap } from '../model';
// @ts-ignore
import type { PostfixMapType } from '../model';
// @ts-ignore
import type { QueueItem } from '../model';
// @ts-ignore
import type { QueueName } from '../model';
// @ts-ignore
import type { RelayHeaderSecret } from '../model';
// @ts-ignore
import type { StandardMainSettings } from '../model';
/**
 * MTAApi - axios parameter creator
 * @export
 */
export const MTAApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerBounceMailFromQueue: async (requestBody: Array<string>, queueName?: QueueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerBounceMailFromQueue', 'requestBody', requestBody)
            const localVarPath = `/api/mta/bounceMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerCreateMap: async (type: PostfixMapType, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('mTAControllerCreateMap', 'type', type)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('mTAControllerCreateMap', 'name', name)
            const localVarPath = `/api/mta/createMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerDeleteMailFromQueue: async (requestBody: Array<string>, queueName?: QueueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerDeleteMailFromQueue', 'requestBody', requestBody)
            const localVarPath = `/api/mta/deleteMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerDeleteMap: async (type: PostfixMapType, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('mTAControllerDeleteMap', 'type', type)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('mTAControllerDeleteMap', 'name', name)
            const localVarPath = `/api/mta/deleteMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerFlushQueue: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/flushQueue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} queueID 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMail: async (queueID: string, maxSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueID' is not null or undefined
            assertParamExists('mTAControllerGetMail', 'queueID', queueID)
            const localVarPath = `/api/mta/getMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueID !== undefined) {
                localVarQueryParameter['queueID'] = queueID;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMainConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/getMainConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMapContent: async (type: PostfixMapType, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('mTAControllerGetMapContent', 'type', type)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('mTAControllerGetMapContent', 'name', name)
            const localVarPath = `/api/mta/getMapContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetPostfixStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/getPostfixStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetQueueList: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/getQueueList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetQueueSize: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/getQueueSize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetStandardMainSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/getStandardSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerHoldMailFromQueue: async (requestBody: Array<string>, queueName?: QueueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerHoldMailFromQueue', 'requestBody', requestBody)
            const localVarPath = `/api/mta/holdMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerIsPostfixRunning: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/isPostfixRunning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerListMaps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/listMaps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerReleaseMailFromQueue: async (requestBody: Array<string>, queueName?: QueueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerReleaseMailFromQueue', 'requestBody', requestBody)
            const localVarPath = `/api/mta/releaseMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRequeueMailFromQueue: async (requestBody: Array<string>, queueName?: QueueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerRequeueMailFromQueue', 'requestBody', requestBody)
            const localVarPath = `/api/mta/requeueMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (queueName !== undefined) {
                localVarQueryParameter['queueName'] = queueName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRescheduleDeferredMail: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mTAControllerRescheduleDeferredMail', 'requestBody', requestBody)
            const localVarPath = `/api/mta/rescheduleDeferredMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRestartPostfix: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/restartPostfix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} subject 
         * @param {string} from 
         * @param {string} [textBody] 
         * @param {string} [htmlBody] 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {Array<string>} [to] 
         * @param {Array<string>} [cc] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSendEmail: async (mtaPort: MTAPort, subject: string, from: string, textBody?: string, htmlBody?: string, sender?: string, recipients?: Array<string>, to?: Array<string>, cc?: Array<string>, attachment?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mtaPort' is not null or undefined
            assertParamExists('mTAControllerSendEmail', 'mtaPort', mtaPort)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('mTAControllerSendEmail', 'subject', subject)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('mTAControllerSendEmail', 'from', from)
            const localVarPath = `/api/mta/sendEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mtaPort !== undefined) {
                localVarQueryParameter['mtaPort'] = mtaPort;
            }


            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }
    
            if (textBody !== undefined) { 
                localVarFormParams.append('textBody', textBody as any);
            }
    
            if (htmlBody !== undefined) { 
                localVarFormParams.append('htmlBody', htmlBody as any);
            }
    
            if (sender !== undefined) { 
                localVarFormParams.append('sender', sender as any);
            }
                if (recipients) {
                localVarFormParams.append('recipients', new Blob([JSON.stringify(recipients)], { type: "application/json", }));
            }

                if (to) {
                localVarFormParams.append('to', new Blob([JSON.stringify(to)], { type: "application/json", }));
            }

                if (cc) {
                localVarFormParams.append('cc', new Blob([JSON.stringify(cc)], { type: "application/json", }));
            }

    
            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSendEmailMime: async (mtaPort: MTAPort, sender?: string, recipients?: Array<string>, mime?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mtaPort' is not null or undefined
            assertParamExists('mTAControllerSendEmailMime', 'mtaPort', mtaPort)
            const localVarPath = `/api/mta/sendEmailMime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mtaPort !== undefined) {
                localVarQueryParameter['mtaPort'] = mtaPort;
            }


            if (sender !== undefined) { 
                localVarFormParams.append('sender', sender as any);
            }
                if (recipients) {
                localVarFormParams.append('recipients', new Blob([JSON.stringify(recipients)], { type: "application/json", }));
            }

    
            if (mime !== undefined) { 
                localVarFormParams.append('mime', mime as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetMainConfig: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('mTAControllerSetMainConfig', 'body', body)
            const localVarPath = `/api/mta/setMainConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetMapContent: async (type: PostfixMapType, name: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('mTAControllerSetMapContent', 'type', type)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('mTAControllerSetMapContent', 'name', name)
            const localVarPath = `/api/mta/setMapContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StandardMainSettings} standardMainSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetStandardMainSettings: async (standardMainSettings: StandardMainSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardMainSettings' is not null or undefined
            assertParamExists('mTAControllerSetStandardMainSettings', 'standardMainSettings', standardMainSettings)
            const localVarPath = `/api/mta/setStandardSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(standardMainSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerStartPostfix: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/startPostfix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerStopPostfix: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mta/stopPostfix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddDomainRelayHeaderSecret: async (domain: string, relayHeaderSecret: RelayHeaderSecret, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('mTAEnterpriseControllerAddDomainRelayHeaderSecret', 'domain', domain)
            // verify required parameter 'relayHeaderSecret' is not null or undefined
            assertParamExists('mTAEnterpriseControllerAddDomainRelayHeaderSecret', 'relayHeaderSecret', relayHeaderSecret)
            const localVarPath = `/api/mta/addDomainRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(relayHeaderSecret, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddGlobalRelayHeaderSecret: async (relayHeaderSecret: RelayHeaderSecret, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relayHeaderSecret' is not null or undefined
            assertParamExists('mTAEnterpriseControllerAddGlobalRelayHeaderSecret', 'relayHeaderSecret', relayHeaderSecret)
            const localVarPath = `/api/mta/addGlobalRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(relayHeaderSecret, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddUserRelayHeaderSecret: async (email: string, relayHeaderSecret: RelayHeaderSecret, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mTAEnterpriseControllerAddUserRelayHeaderSecret', 'email', email)
            // verify required parameter 'relayHeaderSecret' is not null or undefined
            assertParamExists('mTAEnterpriseControllerAddUserRelayHeaderSecret', 'relayHeaderSecret', relayHeaderSecret)
            const localVarPath = `/api/mta/addUserRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(relayHeaderSecret, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteDomainRelayHeaderSecret: async (domain: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('mTAEnterpriseControllerDeleteDomainRelayHeaderSecret', 'domain', domain)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mTAEnterpriseControllerDeleteDomainRelayHeaderSecret', 'id', id)
            const localVarPath = `/api/mta/deleteDomainRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret', 'id', id)
            const localVarPath = `/api/mta/deleteGlobalRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteUserRelayHeaderSecret: async (email: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('mTAEnterpriseControllerDeleteUserRelayHeaderSecret', 'email', email)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mTAEnterpriseControllerDeleteUserRelayHeaderSecret', 'id', id)
            const localVarPath = `/api/mta/deleteUserRelayHeaderSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MTAApi - functional programming interface
 * @export
 */
export const MTAApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MTAApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerBounceMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerBounceMailFromQueue(requestBody, queueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerBounceMailFromQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerCreateMap(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostfixMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerCreateMap(type, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerCreateMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerDeleteMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerDeleteMailFromQueue(requestBody, queueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerDeleteMailFromQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerDeleteMap(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerDeleteMap(type, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerDeleteMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerFlushQueue(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerFlushQueue(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerFlushQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} queueID 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetMail(queueID: string, maxSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetMail(queueID, maxSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetMainConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetMainConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetMainConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetMapContent(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetMapContent(type, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetMapContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetPostfixStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetPostfixStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetPostfixStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetQueueList(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueueItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetQueueList(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetQueueList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetQueueSize(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetQueueSize(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetQueueSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerGetStandardMainSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandardMainSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerGetStandardMainSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerGetStandardMainSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerHoldMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerHoldMailFromQueue(requestBody, queueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerHoldMailFromQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerIsPostfixRunning(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerIsPostfixRunning(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerIsPostfixRunning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerListMaps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostfixMap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerListMaps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerListMaps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerReleaseMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerReleaseMailFromQueue(requestBody, queueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerReleaseMailFromQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerRequeueMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerRequeueMailFromQueue(requestBody, queueName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerRequeueMailFromQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerRescheduleDeferredMail(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerRescheduleDeferredMail(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerRescheduleDeferredMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerRestartPostfix(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerRestartPostfix(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerRestartPostfix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} subject 
         * @param {string} from 
         * @param {string} [textBody] 
         * @param {string} [htmlBody] 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {Array<string>} [to] 
         * @param {Array<string>} [cc] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerSendEmail(mtaPort: MTAPort, subject: string, from: string, textBody?: string, htmlBody?: string, sender?: string, recipients?: Array<string>, to?: Array<string>, cc?: Array<string>, attachment?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerSendEmail(mtaPort, subject, from, textBody, htmlBody, sender, recipients, to, cc, attachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerSendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerSendEmailMime(mtaPort: MTAPort, sender?: string, recipients?: Array<string>, mime?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerSendEmailMime(mtaPort, sender, recipients, mime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerSendEmailMime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerSetMainConfig(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerSetMainConfig(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerSetMainConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerSetMapContent(type: PostfixMapType, name: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerSetMapContent(type, name, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerSetMapContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StandardMainSettings} standardMainSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerSetStandardMainSettings(standardMainSettings: StandardMainSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerSetStandardMainSettings(standardMainSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerSetStandardMainSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerStartPostfix(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerStartPostfix(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerStartPostfix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAControllerStopPostfix(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAControllerStopPostfix(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAControllerStopPostfix']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain: string, relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain, relayHeaderSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerAddDomainRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerAddGlobalRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerAddUserRelayHeaderSecret(email: string, relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerAddUserRelayHeaderSecret(email, relayHeaderSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerAddUserRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerDeleteDomainRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MTAApi.mTAEnterpriseControllerDeleteUserRelayHeaderSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MTAApi - factory interface
 * @export
 */
export const MTAApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MTAApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerBounceMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerBounceMailFromQueue(requestBody, queueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerCreateMap(type: PostfixMapType, name: string, options?: any): AxiosPromise<PostfixMap> {
            return localVarFp.mTAControllerCreateMap(type, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerDeleteMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerDeleteMailFromQueue(requestBody, queueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerDeleteMap(type: PostfixMapType, name: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerDeleteMap(type, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerFlushQueue(options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerFlushQueue(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} queueID 
         * @param {number} [maxSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMail(queueID: string, maxSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.mTAControllerGetMail(queueID, maxSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMainConfig(options?: any): AxiosPromise<string> {
            return localVarFp.mTAControllerGetMainConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetMapContent(type: PostfixMapType, name: string, options?: any): AxiosPromise<string> {
            return localVarFp.mTAControllerGetMapContent(type, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetPostfixStatus(options?: any): AxiosPromise<string> {
            return localVarFp.mTAControllerGetPostfixStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetQueueList(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<QueueItem>> {
            return localVarFp.mTAControllerGetQueueList(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetQueueSize(options?: any): AxiosPromise<number> {
            return localVarFp.mTAControllerGetQueueSize(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerGetStandardMainSettings(options?: any): AxiosPromise<StandardMainSettings> {
            return localVarFp.mTAControllerGetStandardMainSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerHoldMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerHoldMailFromQueue(requestBody, queueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerIsPostfixRunning(options?: any): AxiosPromise<boolean> {
            return localVarFp.mTAControllerIsPostfixRunning(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerListMaps(options?: any): AxiosPromise<Array<PostfixMap>> {
            return localVarFp.mTAControllerListMaps(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerReleaseMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerReleaseMailFromQueue(requestBody, queueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {QueueName} [queueName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRequeueMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerRequeueMailFromQueue(requestBody, queueName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRescheduleDeferredMail(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerRescheduleDeferredMail(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerRestartPostfix(options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerRestartPostfix(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} subject 
         * @param {string} from 
         * @param {string} [textBody] 
         * @param {string} [htmlBody] 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {Array<string>} [to] 
         * @param {Array<string>} [cc] 
         * @param {File} [attachment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSendEmail(mtaPort: MTAPort, subject: string, from: string, textBody?: string, htmlBody?: string, sender?: string, recipients?: Array<string>, to?: Array<string>, cc?: Array<string>, attachment?: File, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerSendEmail(mtaPort, subject, from, textBody, htmlBody, sender, recipients, to, cc, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MTAPort} mtaPort 
         * @param {string} [sender] 
         * @param {Array<string>} [recipients] 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSendEmailMime(mtaPort: MTAPort, sender?: string, recipients?: Array<string>, mime?: File, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerSendEmailMime(mtaPort, sender, recipients, mime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetMainConfig(body: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerSetMainConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostfixMapType} type 
         * @param {string} name 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetMapContent(type: PostfixMapType, name: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerSetMapContent(type, name, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StandardMainSettings} standardMainSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerSetStandardMainSettings(standardMainSettings: StandardMainSettings, options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerSetStandardMainSettings(standardMainSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerStartPostfix(options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerStartPostfix(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAControllerStopPostfix(options?: any): AxiosPromise<void> {
            return localVarFp.mTAControllerStopPostfix(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain: string, relayHeaderSecret: RelayHeaderSecret, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain, relayHeaderSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret: RelayHeaderSecret, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {RelayHeaderSecret} relayHeaderSecret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerAddUserRelayHeaderSecret(email: string, relayHeaderSecret: RelayHeaderSecret, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerAddUserRelayHeaderSecret(email, relayHeaderSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MTAApi - object-oriented interface
 * @export
 * @class MTAApi
 * @extends {BaseAPI}
 */
export class MTAApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {QueueName} [queueName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerBounceMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerBounceMailFromQueue(requestBody, queueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostfixMapType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerCreateMap(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerCreateMap(type, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {QueueName} [queueName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerDeleteMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerDeleteMailFromQueue(requestBody, queueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostfixMapType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerDeleteMap(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerDeleteMap(type, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerFlushQueue(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerFlushQueue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} queueID 
     * @param {number} [maxSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetMail(queueID: string, maxSize?: number, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetMail(queueID, maxSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetMainConfig(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetMainConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostfixMapType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetMapContent(type: PostfixMapType, name: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetMapContent(type, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetPostfixStatus(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetPostfixStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetQueueList(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetQueueList(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetQueueSize(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetQueueSize(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerGetStandardMainSettings(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerGetStandardMainSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {QueueName} [queueName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerHoldMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerHoldMailFromQueue(requestBody, queueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerIsPostfixRunning(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerIsPostfixRunning(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerListMaps(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerListMaps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {QueueName} [queueName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerReleaseMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerReleaseMailFromQueue(requestBody, queueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {QueueName} [queueName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerRequeueMailFromQueue(requestBody: Array<string>, queueName?: QueueName, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerRequeueMailFromQueue(requestBody, queueName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerRescheduleDeferredMail(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerRescheduleDeferredMail(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerRestartPostfix(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerRestartPostfix(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MTAPort} mtaPort 
     * @param {string} subject 
     * @param {string} from 
     * @param {string} [textBody] 
     * @param {string} [htmlBody] 
     * @param {string} [sender] 
     * @param {Array<string>} [recipients] 
     * @param {Array<string>} [to] 
     * @param {Array<string>} [cc] 
     * @param {File} [attachment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerSendEmail(mtaPort: MTAPort, subject: string, from: string, textBody?: string, htmlBody?: string, sender?: string, recipients?: Array<string>, to?: Array<string>, cc?: Array<string>, attachment?: File, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerSendEmail(mtaPort, subject, from, textBody, htmlBody, sender, recipients, to, cc, attachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MTAPort} mtaPort 
     * @param {string} [sender] 
     * @param {Array<string>} [recipients] 
     * @param {File} [mime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerSendEmailMime(mtaPort: MTAPort, sender?: string, recipients?: Array<string>, mime?: File, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerSendEmailMime(mtaPort, sender, recipients, mime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerSetMainConfig(body: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerSetMainConfig(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostfixMapType} type 
     * @param {string} name 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerSetMapContent(type: PostfixMapType, name: string, body?: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerSetMapContent(type, name, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StandardMainSettings} standardMainSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerSetStandardMainSettings(standardMainSettings: StandardMainSettings, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerSetStandardMainSettings(standardMainSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerStartPostfix(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerStartPostfix(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAControllerStopPostfix(options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAControllerStopPostfix(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {RelayHeaderSecret} relayHeaderSecret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain: string, relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerAddDomainRelayHeaderSecret(domain, relayHeaderSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RelayHeaderSecret} relayHeaderSecret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerAddGlobalRelayHeaderSecret(relayHeaderSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {RelayHeaderSecret} relayHeaderSecret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerAddUserRelayHeaderSecret(email: string, relayHeaderSecret: RelayHeaderSecret, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerAddUserRelayHeaderSecret(email, relayHeaderSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain: string, id: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerDeleteDomainRelayHeaderSecret(domain, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerDeleteGlobalRelayHeaderSecret(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MTAApi
     */
    public mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email: string, id: string, options?: RawAxiosRequestConfig) {
        return MTAApiFp(this.configuration).mTAEnterpriseControllerDeleteUserRelayHeaderSecret(email, id, options).then((request) => request(this.axios, this.basePath));
    }
}

